<template>
    <el-dialog
        title="Find Jobs"
        :visible.sync="showForm"
        width="80%"
        :destroy-on-close="true"
        append-to-body
    >
        <form class="form-inline" @submit.prevent="filterJobs">
            <div class="form-group mb-2">
                <label>Filter</label>
                <input type="text" v-model="filter" class="form-control" style="width: 350px;" placeholder="by ID, Title, Admin Title, Referrer">
            </div>
            <div class="form-group mx-sm-3 mb-2">
                <label>Category</label>
                <el-select v-model="categories" clearable multiple filterable placeholder="Categories" style="width: 350px;">
                    <el-option
                        v-for="(option) in category_options"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>
            <button type="submit" class="btn btn-primary mb-2">Filter</button>
        </form>

        <div class="table-responsive table-fix-head" style="max-height: 550px; overflow-y: auto; margin-top: 50px;" v-loading="loading">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th style="width: 30px;">
                        <input type="checkbox" @click="toggleAll" :checked="checked_jobs.length > 0"></input>
                    </th>
                    <th style="width: 80px;">ID</th>
                    <th>Title</th>
                    <th style="max-width: 400px;">Categories</th>
                    <th style="width: 140px;">States</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="j in jobs" @click="toggleJob(j.id)">
                    <td><input type="checkbox" :checked="checked_jobs.includes(j.id)"></input></td>
                    <td>{{ j.id }}</td>
                    <td>{{ j.title }}<br>
                        <i>{{ j.admin_description }}</i>
                    </td>
                    <td>
                        <div v-for="tag in j.categories" style="display:inline-block; margin-bottom:5px;">
                            <span class="label"
                                  :class="{ 'label-default' : (tag != 'Owner Operators'), 'label-primary' : (tag == 'Owner Operators') }"
                                  style="margin-right:5px">{{ tag }}</span>
                        </div>
                    </td>
                    <td>{{ j.state_code_list }}<br>
                        States: {{ j.state_count }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="addJobs">Add Jobs</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'employer_id',
        'exclude_campaign_id',
        'exclude_job_id'
    ],
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    data() {
        return {
            category_options: window.categories_flat,

            filter: '',
            categories: [],
            loading: true,

            checked_jobs: [],

            jobs: []
        };
    },
    watch: {
        employer_id() {
            this.filterJobs();
        },
        exclude_campaign_id() {
            this.filterJobs();
        },
        exclude_job_id() {
            this.filterJobs();
        }
    },
    methods: {
        filterJobs() {
            this.loading = true;
            return axios.post(url(`admin/employer/${this.employer_id}/campaign-jobs-search`), {
                    'filter': this.filter,
                    'categories': this.categories,
                    'exclude_campaign_id': this.exclude_campaign_id
                }).then(response => {
                    let excluded_job_id = parseInt(this.exclude_job_id);
                    this.jobs = _.filter(response.data.jobs, j => j.id !== excluded_job_id);
                    this.loading = false;
                });
        },
        toggleJob(id) {
            if (this.checked_jobs.includes(id)) {
                this.checked_jobs = _.filter(this.checked_jobs, x => x !== id);
            }
            else {
                this.checked_jobs = this.checked_jobs.concat([id]);
            }
        },
        toggleAll() {
            if (this.checked_jobs.length > 0) {
                this.checked_jobs = [];
            }
            else {
                this.checked_jobs = _.map(this.jobs, (x) => x.id);
            }
        },
        addJobs() {
            this.$emit('input', this.checked_jobs);
            this.showForm = false;
        }
    },
    mounted() {
        this.filterJobs();
    }
}
</script>

<style>
.label-default {
    background-color: #777777;
}
.label-primary {
    background-color: #337ab7;
}
.label {
    display: inline;
    padding: 0.2em 0.6em 0.3em;
    font-size: 75%;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25em;
}
.btn-primary {
    background-image: none;
    background-color: #fc0;
    border: 1px solid #fc0;
    color: #2D3E4F;
}
.btn-default, .btn-primary, .btn-success, .btn-info, .btn-warning, .btn-danger {
    text-shadow: none;
    box-shadow: none;
}
.btn {
    font-weight: bold;
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    user-select: none;
}
.form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
}
.form-inline .form-control {
    display: inline-block;
    vertical-align: middle;
}

.form-control {
    color: #2D3E4F;
}
.form-control {
    display: block;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.form-inline, .table-responsive {
    font-family: "open sans", arial, sans-serif;
}
</style>
